import oddHolder from "../../model/odd-holder";

function binomial(n, k) {
	if (k < 0 || k > n) return 0;
	if (k === 0 || k === n) return 1;
	k = Math.min(k, n - k);
	let result = 1;
	for (let i = 1; i <= k; i++) {
		result = (result * (n - k + i)) / i;
	}
	return Math.round(result);
}

/**
 * Theoretical max win for a ticket.
 * Each C(n, 6) combination can win at the earliest possible draw tier:
 *   tier i count = C(5 + i, i), odd = odds table at draw position 6 + i.
 * Odds come from oddHolder (updated from server quotas on login).
 */
export function calculateMaxWin(stakePerCombination, numSelectedNumbers, odds = oddHolder) {
	if (numSelectedNumbers < 6 || !stakePerCombination) {
		return 0;
	}

	const numTiers = numSelectedNumbers - 5;
	let total = 0;

	for (let tier = 0; tier < numTiers; tier++) {
		const tierCount = binomial(5 + tier, tier);
		const odd = odds[5 + tier]?.odd;
		if (odd == null) {
			continue;
		}
		total += stakePerCombination * odd * tierCount;
	}

	return total;
}

export default calculateMaxWin;
